<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <v-row>
            <v-col
              cols="6"
            >
              <base-material-stats-card
                color="indigo"
                icon="mdi-check"
                title="Credits Issued"
                :value="totalpostalcredit"
                sub-text="Updated Hourly"
              />
              <base-material-stats-card
                color="red"
                icon="mdi-mail"
                title="Checks"
                :value="totalpostalchecks"
                sub-text="Updated Hourly"
              />
              <base-material-stats-card
                color="warning"
                icon="mdi-exit-run"
                title="Cash At the Post Office"
                :value="fundsForPickup"
                sub-text="Ready for collection"
              />
              <base-material-stats-card
                color="green"
                icon="mdi-account-check"
                title="Cash Validated (updated hourly)"
                :value="totalpostalvalidated"
                :sub-text="totalpostalvalidatedcount"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <base-material-card
                inline
                class="col-md-12"
                color="lime darken-1"
                title="Checks"
              >
                <v-divider class="mt-3" />
                <v-data-table
                  :headers="checks_header"
                  :items="postalchecks"
                  :search="searchchecks"
                  :items-per-page="5"
                  sort-by="timestamp"
                  sort-desc
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Postal Checks</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      />
                      <v-text-field
                        v-model="searchchecks"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      />
                      <v-spacer />
                    </v-toolbar>
                  </template>
                  <template v-slot:no-data>
                    No Data to display
                  </template>
                </v-data-table>
              </base-material-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-col>
        <base-material-card
          color="primary"
          icon="mdi-mail"
          inline
          title="Postal Packages"
        >
          <v-toolbar
            flat
          >
            <v-toolbar-title>Validate Shipment</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-btn
              to="ChangeOrderShipment"
              color="warning"
            >
              Ship Coin Order
            </v-btn>
            <v-btn
              to="PostalVerifyManagement"
              color="warning"
            >
              Verify Packages
            </v-btn>
            <download-csv
              :name="csvfilename()"
              :data="packagesStagged"
            >
              <v-btn color="info">
                <v-icon
                  color="white"
                  left
                >
                  mdi-arrow-down
                </v-icon>CSV
              </v-btn>
            </download-csv>
          </v-toolbar>
          <v-dialog
            v-model="dialogusps"
            max-width="700px"
          >
            <v-card>
              <v-toolbar>
                <v-toolbar-title>Address Validation</v-toolbar-title>

                <v-progress-linear
                  :active="loading"
                  :indeterminate="loading"
                  absolute
                  bottom
                  color="deep-purple accent-4"
                />

                <v-spacer />
                <v-btn
                  color="deep-purple accent-4"
                  outlined
                  @click="validateAddress(editedItem)"
                >
                  Check Address
                </v-btn>
                <a
                  :href="getuspstrackingurl(editedItem.tracking_number)"
                  target="_blank"
                >
                  <v-btn
                    color="green"
                    outlined
                  >
                    Check Status
                  </v-btn>
                </a>

                <v-btn
                  outlined
                  color="black"
                  disabled
                  @click="callUSPSPickup(editedItem)"
                >
                  Call Pick Up
                </v-btn>
              </v-toolbar>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-img
                    height="150"
                    contain
                    src="/img/uspslogo.png"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-list v-if="editedItem.sitedetails">
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon large>
                          mdi-store-marker
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Site Name: {{ editedItem.sitedetails.idnum }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon large>
                          mdi-text-box-multiple
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Address: {{ editedItem.sitedetails.address }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon large>
                          mdi-city
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>City: {{ editedItem.sitedetails.city }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon large>
                          mdi-map-legend
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>State: {{ editedItem.sitedetails.state }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-list>
                    <v-list-item v-if="postalMessage">
                      <v-list-item-icon>
                        <v-icon large>
                          mdi-account-voice
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        {{ postalMessage }}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col />
              </v-row>
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  outlined
                  @click="closeusps"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-col
            sm="12"
            md="12"
            lg="12"
          >
            <base-material-card
              inline
              class="col-md-12"
              color="lime darken-1"
              title="Packages Staged"
            >
              <v-divider class="mt-3" />
              <v-data-table
                :headers="packages_stagged_header"
                :items="packagesStagged"
                :search="searchstagged"
                :items-per-page="20"
                sort-by="timestamp"
                sort-desc
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Status Information</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-text-field
                      v-model="searchstagged"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.ship_date`]="{ item }">
                  {{ format_time(item.ship_date) }}
                </template>
                <template
                  v-slot:[`item.verify`]="{ item }"
                >
                  <v-icon

                    color="purple lighten-1"
                    size="20"
                    @click="verifyItem(item)"
                  >
                    mdi-email-search
                  </v-icon>
                </template>
                <template v-slot:[`item.verifiedstatus`]="{ item }">
                  <div v-if="item.verifiedstatus === false">
                    <v-icon
                      color="warning"
                    >
                      mdi-account-question
                    </v-icon>
                  </div>
                  <div v-if="item.verifiedstatus === true">
                    <v-icon color="green">
                      mdi-account-check
                    </v-icon>
                  </div>
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ format_time(item.timestamp) }}
                </template>
                <template v-slot:[`item.totalcurrency`]="{ item }">
                  {{ format_amt(item.totalcurrency) }}
                </template>
                <template v-slot:no-data>
                  No Data to display
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>
          <v-col
            sm="12"
            md="12"
            lg="12"
          >
            <base-material-card
              inline
              class="col-md-12"
              color="purple darken-3"
              title="Packages Transit"
            >
              <v-divider class="mt-3" />

              <v-data-table
                :headers="packages_header"
                :items="packagesInTransit"
                :search="searchTransit"
                :items-per-page="20"
                sort-by="ship_date"
                sort-desc
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Status Information</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-text-field
                      v-model="searchdelivered"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.totalcurrency`]="{ item }">
                  {{ format_amt(item.totalcurrency) }}
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ format_time(item.timestamp) }}
                </template>
                <template v-slot:[`item.ship_date`]="{ item }">
                  {{ format_time(item.ship_date) }}
                </template>
                <template v-slot:no-data>
                  No Data to display
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>
          <v-col
            sm="12"
            md="12"
            lg="12"
          >
            <base-material-card
              inline
              class="col-md-12"
              color="light-green darken-1"
              title="Packages delivered"
            >
              <v-divider class="mt-3" />

              <v-data-table
                :headers="packages_delivered_header"
                :items="packagesDelivered"
                :search="searchdelivered"
                :items-per-page="20"
                sort-by="ship_date"
                sort-desc
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Status Information</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-text-field
                      v-model="searchdelivered"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.verifiedstatus`]="{ item }">
                  <div v-if="item.verifiedstatus === false">
                    <v-icon
                      color="warning"
                    >
                      mdi-account-question
                    </v-icon>
                  </div>
                  <div v-if="item.verifiedstatus === true">
                    <v-icon color="green">
                      mdi-account-check
                    </v-icon>
                  </div>
                </template>
                <template v-slot:[`item.ship_date`]="{ item }">
                  {{ format_time(item.ship_date) }}
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ format_time(item.timestamp) }}
                </template>
                <template v-slot:[`item.totalcurrency`]="{ item }">
                  {{ format_amt(item.totalcurrency) }}
                </template>
                <template v-slot:no-data>
                  No Data to display
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>
        </base-material-card>

        <div class="py-3" />
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
      >
        <base-material-card
          inline
          class="col-md-12"
          color="lime darken-1"
          title="All Packages"
        >
          <v-divider class="mt-3" />
          <v-data-table
            :headers="packages_stagged_header"
            :items="allpackages"
            :search="searchstagged"
            :items-per-page="20"
            sort-by="timestamp"
            sort-desc
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <v-toolbar-title>Status Information</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                />
                <v-text-field
                  v-model="searchstagged"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                />
                <v-spacer />
              </v-toolbar>
            </template>
            <template v-slot:[`item.ship_date`]="{ item }">
              {{ format_time(item.ship_date) }}
            </template>
            <template v-slot:[`item.timestamp`]="{ item }">
              {{ format_time(item.timestamp) }}
            </template>
            <template v-slot:[`item.totalcurrency`]="{ item }">
              {{ format_amt(item.totalcurrency) }}
            </template>
            <template v-slot:no-data>
              No Data to display
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'PostalDash',

    data () {
      return {
        bal: '',
        searchdelivered: '',
        searchstagged: '',
        searchTransit: '',
        searchchecks: '',
        search: '',
        packages: '',
        dialogusps: false,
        valid: true,
        packages_header: [
          { text: 'Created', value: 'timestamp', align: 'center', sortable: false },
          { text: 'Sites ID', value: 'siteid', sortable: true },
          { text: 'Ship Date', value: 'ship_date', align: 'center', sortable: false },
          { text: 'Package Currency', value: 'totalcurrency', align: 'center', sortable: false },
          { text: 'Tracking', value: 'tracking_number', align: 'center', sortable: false },
          { text: 'Latest Event', value: 'lastevent', align: 'center', sortable: true },
          { text: 'Status Desc', value: 'status_description', align: 'center', sortable: true }
        ],
        packages_delivered_header: [
          { text: 'Created', value: 'timestamp', align: 'center', sortable: false },
          { text: 'Sites ID', value: 'siteid', sortable: true },
          { text: 'Ship Date', value: 'ship_date', align: 'center', sortable: false },
          { text: 'Package Currency', value: 'totalcurrency', align: 'center', sortable: false },
          { text: 'Tracking', value: 'tracking_number', align: 'center', sortable: false },
          { text: 'Verified', align: 'center', value: 'verifiedstatus', sortable: true },
          { text: 'Latest Event (SE API)', value: 'lastevent', align: 'center', sortable: true },
          { text: 'Status', value: 'ptstatus', align: 'center', sortable: true },
          { text: 'Status Desc', value: 'ptdescription', align: 'center', sortable: true },
          { text: 'Del Stages', value: 'eventlength', align: 'center', sortable: true }
        ],
        packages_stagged_header: [
          { text: 'Created', value: 'timestamp', align: 'center', sortable: false },
          { text: 'Sites ID', value: 'siteid', sortable: true },
          { text: 'Package Currency', value: 'totalcurrency', align: 'center', sortable: false },
          { text: 'Tracking', value: 'tracking_number', align: 'center', sortable: false },
          { text: 'Status Desc', value: 'status_description', align: 'center', sortable: true },
          { text: 'Del Stages', value: 'eventlength', align: 'center', sortable: true },
          { text: 'Verified', value: 'verifiedstatus', align: 'center', sortable: true },
          { text: 'Verify', value: 'verify', align: 'center', sortable: true }
        ],
        checks_header: [
          { text: 'Date', value: 'date', align: 'center', sortable: false },
          { text: 'Sites ID', value: 'siteid', sortable: true },
          { text: 'Check Amount', value: 'checkAmount', align: 'center', sortable: false },
        ],
        headers: [
          { text: 'Sites ID', value: 'idnum', sortable: true },
          { text: 'Deposit Bags', value: 'postdeposits', align: 'center', sortable: false },
          { text: 'Ship Packages', value: 'postshipments', align: 'center', sortable: false },
          { text: 'Tracking', value: 'tracking', align: 'center', sortable: false },
        ],
        items: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        editedIndex: -1,
        editedItem: {
          idnum: '',
          crypto_idnum: '',
          originalidnum: '',
          nightlyrestart: '',
          sitekey: '',
          sitetype: '',
          schedule: '',
          address: '',
          city: '',
          state: '',
          zipcode: '',
          group: '',
          shipmentspermonth: '',
          changeSystemID: '',
          changeProvider: '',
          allowedusers: null,
          changeorderprofiles: [],
          locationTags: null,
          safeType: 'none',
          noteCapacity: '',
          provCredit: false,
          creditprovider: '',
          creditproviderId: '',
          creditproviderLocationID: '',
          creditproviderapikey: '',
          wifipw: '',
          externalsafe: false,
          wifiaccess: '',
          country: '',
          sitecontactnumber: '',
          sitecontactname: '',
          supportemail: '',
          supportnumber: '',
          timezone: '',
          time_open: '08:00',
          time_close: '23:00',
          time_eod: '01:00',
          time_deposit_summary: ''
        },
        defaultItem: {
          idnum: '',
          crypto_idnum: '',
          originalidnum: '',
          nightlyrestart: '',
          address: '',
          sitekey: '',
          sitetype: '',
          shipmentspermonth: '',
          schedule: '',
          city: '',
          state: '',
          zipcode: '',
          externalsafe: false,
          wifipw: '',
          wifiaccess: '',
          group: '',
          changeSystemID: '',
          changeProvider: '',
          allowedusers: [],
          changeorderprofiles: [],
          locationTags: [],
          safeType: '',
          noteCapacity: '',
          provCredit: false,
          creditprovider: '',
          creditproviderId: '',
          creditproviderLocationID: '',
          country: '',
          sitecontactnumber: '',
          sitecontactname: '',
          supportemail: '',
          supportnumber: '',
          timezone: '',
          time_open: '08:00',
          time_close: '23:00',
          time_eod: '01:00',
          time_deposit_summary: ''
        },
        tabs: 0,
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      postalMessage () {
        let message = ''
        message = this.$store.getters.getPostalMessage
        return message
      },
      totalpostalcredit () {
        return numeral(this.$store.getters.getgrosspostaldeposits).format('$0,000.00')
      },
      totalpostalvalidated () {
        // console.log('### GROSS VALIDATED ', this.$store.getters.getgrossvalidated)
        let totalvalidated = '$0.00'
        totalvalidated = numeral(this.$store.getters.getgrossvalidated.value).format('$0.00')
        // console.log('### total validated ', totalvalidated)
        return totalvalidated
      },
      totalpostalvalidatedcount () {
        return 'Total Packages Validated ' + this.$store.getters.getgrossvalidated.count
      },
      totalpostalchecks () {
        let totalchecks = this.$store.getters.getpostalchecks.reduce((acc, val) => acc + parseFloat(val.checkAmount), 0)
        return numeral(totalchecks).format('$0,000.00')
      },
      totalPostalDelivered () {

      },
      totalVerifiedDeposits () {

      },
      totalPostalDeposits () {

      },
      postalchecks () {
        let checks = this.$store.getters.getpostalchecks
        checks.forEach(entry => {
          Object.assign(entry, { date: moment(entry.timestamp).format('YYYY-MM-DD') })
        })
        return checks
      },
      currentsafes () {
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return this.$store.getters.safesstatus
      },
      allpackages () {
        // console.log('total ', this.$store.getters.loadedPostalPackages.length)
        // demo ones have no tracking number
        let packs = []
        this.$store.getters.loadedPostalPackages.forEach(pack => {
          Object.assign(pack, { eventlength: pack.events.length })
          packs.push(pack)
          // eventlength: entry.events.length
        })
        // console.log('staged ', packs)
        packs.forEach(pack => {
          this.$store.getters.loadedSites.forEach(loadedSite => {
            if (pack.sitekey === loadedSite.sitekey) {
              Object.assign(pack, { sitedetails: loadedSite })
            }
          })
        })
        return packs
      },
      packagesStagged () {
        // console.log('total ', this.$store.getters.loadedPostalPackages.length)
        // demo ones have no tracking number
        let packs = []
        console.log('total staged ', this.$store.getters.loadedPostalPackages.length)
        this.$store.getters.loadedPostalPackages.forEach(pack => {
          let TODAY = moment()
          let packagedate = moment(pack.timestamp)
          console.log('date compare ', TODAY.format('YYYY-MM-DD'), packagedate.format('YYYY-MM-DD'))
          if (TODAY.diff(packagedate, 'days') < 90) {
            console.log('item is before 90 days', TODAY.diff(packagedate, 'days'))
            Object.assign(pack, { eventlength: pack.events.length })
            // eventlength: entry.events.length
            console.log(pack)
            if (pack.tracking_number && pack.status_description === 'initial_create' && pack.siteid !== 'DunbarDemo' && pack.siteid !== 'Smart Safe USA') {
              packs.push(pack)
            }
            if (pack.tracking_number && pack.status_code === 'AC') {
              if (pack.events.length > 1) {
              // console.log('this has moved ', pack)
              }
              let atpobox = ''
              atpobox = pack.events.find(entry => {
                if (entry.city_locality === 'FLORAL PARK' && entry.description === 'AVAILABLE FOR PICKUP' && entry.event_code === '14') {
                  return true
                }
                return false
              })
              if (atpobox) {
              // console.log('this was not staged and is at po box ', atpobox, pack)
              } else {
                let evermoved = pack.events.find(ele => ele.event_code === '03')
                if (evermoved) {
                  console.log('usps took posession ')
                } else {
                  if (pack.verifiedstatus !== true) {
                    packs.push(pack)
                  }
                }
              }
            }
          }
        })
        // console.log('staged ', packs)
        // for all the packs add in their address information from the sitekey
        return packs
      },
      packagesDelivered () {
        let deliveredpacks = []
        let packages = this.$store.getters.loadedPostalPackages
        // let packs = packages.filter(entry => entry.status_description === 'Delivered')
        // console.log(packs)
        packages.forEach(entry => {
          let everdelivered = ''
          everdelivered = entry.events.find(ele => ele.event_code === '14')
          if (everdelivered) {
            let vstatus = false
            if (entry.verifiedstatus) {
              // console.log('this one was verified! ', entry)
              vstatus = entry.verifiedstatus
            }
            Object.assign(entry, { verifiedstatus: vstatus })
            Object.assign(entry, { ptstatus: 'Delivered', ptdescription: 'At NYC PO', eventlength: entry.events.length })
            deliveredpacks.push(entry)
          }
        })

        return deliveredpacks
      },
      fundsForPickup () {
        let deliveredpacks = []
        let packages = this.$store.getters.loadedPostalPackages
        // let packs = packages.filter(entry => entry.status_description === 'Delivered')
        // console.log(packs)
        let fundsforPickup = 0
        packages.forEach(entry => {
          let everdelivered = ''
          everdelivered = entry.events.find(ele => ele.event_code === '14')
          if (everdelivered) {
            let vstatus = false
            if (entry.verifiedstatus) {
              // console.log('this one was verified! ', entry)
              vstatus = entry.verifiedstatus
            }
            Object.assign(entry, { verifiedstatus: vstatus })
            Object.assign(entry, { ptstatus: 'Delivered', ptdescription: 'At NYC PO', eventlength: entry.events.length })
            if (entry.verifiedstatus === false) {
              fundsforPickup += entry.totalcurrency
              deliveredpacks.push(entry)
            }
          }
        })

        // console.log('funds at PO ', deliveredpacks)
        return numeral(fundsforPickup).format('$0,00.00')
      },
      packagesInTransit () {
        let packs = []
        this.$store.getters.loadedPostalPackages.forEach(pack => {
          if (pack.events[0]) {
            Object.assign(pack, { lastevent: pack.events[0].event_description })
          }
          Object.assign(pack, { eventlength: pack.events.length })
          if (pack.events.length > 1 && pack.status_code === 'AC') {
            // console.log('this has moved ', pack)
            packs.push(pack)
          }
          if (pack.tracking_number && pack.status_code !== '' && pack.status_code !== 'DE' && pack.status_code !== 'AC') {
            // check to see if this package has event_code 14 in its events list, if not then add it
            let everdelivered = ''
            everdelivered = pack.events.find(entry => entry.event_code === '14')
            if (everdelivered) {
              // console.log('this one was delivered ', pack)
            } else {
              packs.push(pack)
            }
          }
        })
        console.log('transit ', packs)
        return packs
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
      this.$store.dispatch('loadpackagestransit')
      this.$store.dispatch('loadpackagesdelivered')
      this.$store.dispatch('loadGrossPostalDeposits')
      this.$store.dispatch('loadGrossVerified')
      this.$store.dispatch('loadPostalSumDay')
      this.$store.dispatch('loadGrossChecks')

      this.packages = this.$store.getters.loadedPostalPackages
      this.getlocs()
      // this.$store.dispatch('resetsafetransactions')
      // this.items = this.$store.getters.safesstatus
    },
    methods: {
      getuspstrackingurl (tracking_number) {
        let url = ''
        if (tracking_number) {
          url = 'https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=' + tracking_number
        }
        return url
      },
      checkStatus (item) {

      },
      callUSPSPickup (item) {

      },
      validateAddress (item) {
        console.log('validate this ', item)
        let details = item.sitedetails
        let location = {
          'FirstName': details.group,
          'LastName': details.sitecontactname,
          'FirmName': details.siteid,
          'SuiteOrApt': '',
          'Address1': '',
          'Address2': details.address,
          'City': details.city,
          'State': details.state,
          'ZIP5': details.zipcode,
          'ZIP4': '',
          'Phone': details.sitecontactnumber
        }
        this.$store.dispatch('validatePostalAddress', location)
      },
      closeusps () {
        this.dialogusps = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
        this.$store.dispatch('clearPostalMessage')
      },
      verifyItem (item) {
        console.log('verify item', item)
        this.editedIndex = this.packagesStagged.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogusps = true
        console.log('verify item', this.dialogusps, item)
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_postalstaged' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      format_time (ts) {
        this.$log.debug('TS passed to table is ', ts)
        return moment(ts).format('YYYY-MM-DD HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          this.$log.debug('key value is ', key)
          let name = 'Unknown'
          let group = 'Unknown'
          let allowedusers = []
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return true
            }
          })
          this.$log.debug('LOC IS ', loc)
          if (loc) {
            group = loc.group
            name = loc.sitename
            allowedusers = loc.allowedusers
          }
          if (value.siteunitsprofile) {
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            let shop = {
              siteid: key,
              group: group,
              safeid: safeid,
            }
            let stat = this.$store.getters.user.status
            let usrmail = this.$store.getters.user.email
            if (stat === 'admin' || stat === 'corporate' || this.$store.getters.user.institution) {
              this.locations.push(shop)
            } else if (stat === 'storemanager' || stat === 'groupmanager' || stat === 'deposituser' || stat === 'vieweronly' || stat === 'deposituser') {
              if (allowedusers) {
                if (allowedusers.includes(usrmail)) {
                  this.locations.push(shop)
                }
              }
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        // if its a postal site get the packages
        let postallocs = this.locations.filter(entry => entry.safeid.includes('PostalSafe'))
        let postalsafes = postallocs.map(entry => entry.safeid)
        this.$store.dispatch('loadpackagesstaged', postalsafes)
        // this.$store.dispatch('loadpackages_staged', postalsafes)

        return this.locations
      },
      log () {
        // this.$store.dispatch('loadsafes')
      },
      request_mailbox_deposit (machine) {
        this.$log.debug('REQUEST POST CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$log.debug('machine id passed ', machine.safeid)
        this.$router.push({ path: '/Depositpost/' + machine.safeid })
      },
      request_mailbox_shipments (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositshipments/' + machine.safeid })
      },
      request_mailbox_tracking (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/DepositTracking/' + machine.safeid })
      },
      request_labels (machine) {
        this.$log.debug('REQUEST LABELS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositlabels/' + machine.safeid })
      },
      request_transactions (machineid) {
        this.$log.debug('machine id passed ', machineid)
      },
      reset () {
        this.wallet = ''
        this.dialog = false
      },
      onDecode (result) {
        // strip out crypto:address
        this.wallet.address = result
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
